import React from 'react';
import PropTypes from 'prop-types';

const Condition = ({ theme, fill = '#A6A7B0', ...props }) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.28293 1.69133C6.20792 1.61634 6.1062 1.57422 6.00013 1.57422C5.89407 1.57422 5.79234 1.61634 5.71733 1.69133L1.19173 6.21613C1.15448 6.25329 1.12493 6.29743 1.10476 6.34603C1.0846 6.39462 1.07422 6.44672 1.07422 6.49933C1.07422 6.55195 1.0846 6.60404 1.10476 6.65264C1.12493 6.70124 1.15448 6.74538 1.19173 6.78253L5.71733 11.3073C5.79234 11.3823 5.89407 11.4244 6.00013 11.4244C6.1062 11.4244 6.20792 11.3823 6.28293 11.3073L10.8085 6.78253C10.8458 6.74538 10.8753 6.70124 10.8955 6.65264C10.9157 6.60404 10.926 6.55195 10.926 6.49933C10.926 6.44672 10.9157 6.39462 10.8955 6.34603C10.8753 6.29743 10.8458 6.25329 10.8085 6.21613L6.28293 1.69133ZM5.99973 2.53933L2.03973 6.49933L5.99973 10.4593V2.53933Z"
      fill={fill}
    />
  </svg>
);

Condition.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Condition;
